import React from 'react';
import { bool, string } from 'prop-types';
import { Typography } from '@mui/material';

import Banner from '../Banner';
import InlineLinks from '../InlineLinks';

const FeatureGateBanner = ({ canWriteBilling, upgradeText, ownerUpgradeText }) => {
  return (
    <Banner severity="gated" styles={{ marginBottom: 1, width: 'auto' }} bannerProps={{ 'data-testid': 'feature-gate-banner' }}>
      <Typography variant="body2">
        <InlineLinks text={canWriteBilling ? upgradeText : ownerUpgradeText} />
      </Typography>
    </Banner>
  );
};

export default FeatureGateBanner;

FeatureGateBanner.propTypes = {
  canWriteBilling: bool.isRequired,
  upgradeText: string.isRequired,
  ownerUpgradeText: string,
};

FeatureGateBanner.defaultProps = {
  ownerUpgradeText: 'Contact your team owner to unlock this feature.',
};
